import React from "react";

import { Pill, PillVariants } from "src/design-system/Pill";

type CaseStatusPillProps = {
  status: string;
  subStatus?: string;
  dataLoc?: string;
  variant: PillVariants | undefined | null;
};

export const CaseStatusPill: React.FC<CaseStatusPillProps> = ({
  status,
  subStatus,
  dataLoc,
  variant,
}) => {
  const displayText = subStatus ? `${status} • ${subStatus}` : status;

  return (
    <Pill dataLoc={dataLoc} size="sm" variant={variant || "gray"} maxWidth>
      <Pill.Text>{displayText}</Pill.Text>
    </Pill>
  );
};
